import api from "@/shared/services/apiClient";

export interface AuditLog {
  audit_id: number;
  source_table: string;
  record_id: number;
  operation: "INSERT" | "UPDATE";
  field_name: string;
  old_value: string | null;
  new_value: string | null;
  changed_at: string;
  changed_by: string;
  changed_by_name: string | null;
  user_id?: string | null;
  subject_user_name?: string | null;
  business_unit?: string;
}

export interface AuditSearchFilters {
  source_table?: string;
  field_name?: string;
  changed_by?: string;
  user_id?: string;
  date_from?: string;
  date_to?: string;
  limit?: number;
  offset?: number;
}

export const auditService = {
  // Get full history for a single record (any authenticated user, ownership-checked server-side)
  getByRecord: async (sourceTable: string, recordId: string | number): Promise<AuditLog[]> => {
    const response = await api.get(`/audit/record/${sourceTable}/${recordId}`);
    return response.data;
  },

  // Get all changes made BY a specific user — officers only
  getByUser: async (userId: string, filters: Pick<AuditSearchFilters, "source_table" | "limit" | "offset"> = {}): Promise<AuditLog[]> => {
    const response = await api.get(`/audit/user/${userId}`, { params: filters });
    return response.data;
  },

  // Full filtered search — officers only
  search: async (filters: AuditSearchFilters = {}): Promise<AuditLog[]> => {
    const cleanFilters: Record<string, string | number> = {};
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        cleanFilters[key] = value;
      }
    });
    const response = await api.get("/audit/search", { params: cleanFilters });
    return response.data;
  },
};
